import React, { Component } from "react";
import { connect } from "react-redux";
import { RightOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import "styles/ProfileSummary.scss";
import CATEGORIES from "utils/categories";
import { isPopulated } from "utils/helpers";
import IconCompleted from "assets/Icon-Completed.svg";

class ProfileSummary extends Component {
  state = {
    maxKeywords: 6,
  };

  capKeywordLimit = (list) => {
    const { maxKeywords } = this.state;
    let newSummary;
    if (list.length > maxKeywords) {
      list.splice(maxKeywords, list.length);
      newSummary = list.join(", ");
      newSummary.concat("...");
    } else {
      newSummary = list.join(", ");
    }
    return newSummary;
  };

  // TODO: refactor here
  getInterestSummary = (userIntFos) => {
    if (userIntFos.length === 0) return "Select your interests";
    const { INTEREST } = this.props.input.attributes;
    const interestList = userIntFos.map((int) => INTEREST[int].name);
    return this.capKeywordLimit(interestList);
  };

  getSkillSetSummary = (userSkills) => {
    if (userSkills.length === 0) return "Select your skills";
    const { SKILL } = this.props.input.attributes;
    const skillsList = userSkills.map((ski) => SKILL[ski].name);
    return this.capKeywordLimit(skillsList);
  };

  getPersonalitySummary = (userPersonality) => {
    if (userPersonality.length === 0) return "Select your personality";
    const personalityList = userPersonality.map((per) => per.personality_type);
    return this.capKeywordLimit(personalityList);
  };

  getCareerSummary = (userCareers) => {
    if (userCareers.length === 0) return "Select your intended career";
    const { CAREER } = this.props.input.attributes;
    const careerList = userCareers.map((car) => CAREER[car].name);
    return this.capKeywordLimit(careerList);
  };

  getCourseAreaSummary = (userCourses) => {
    if (userCourses.length === 0) return "Select your relevant uni course";
    const { courses } = this.props.input;
    const courseList = userCourses.map((key) => {
      return `${courses[key].title} (${courses[key].institution})`;
    });
    return this.capKeywordLimit(courseList);
  };

  getCategoryName = (navlink) => {
    return CATEGORIES.find((cat) => {
      return cat.navlink === navlink;
    }).name;
  };

  render() {
    const {
      userInterests,
      userSkills,
      userPersonality,
      userCareers,
      userCourses,
    } = this.props;
    const summaries = {
      Interests: this.getInterestSummary(userInterests),
      SkillsSet: this.getSkillSetSummary(userSkills),
      Personality: this.getPersonalitySummary(userPersonality),
      Career: this.getCareerSummary(userCareers),
      CourseAreas: this.getCourseAreaSummary(userCourses),
    };

    return (
      <div
        className="mobile-only padding-sides profile-summary-container"
        id="profile-summary"
      >
        <h1 className="title">Profile Summary</h1>
        {CATEGORIES.map((cat) => (
          <div key={cat.name} className="profile-summary-item">
            <div className="flex-space-between flex-align-items-center">
              <div>
                <h2 className="profile-summary-item-title">
                  {cat.displayName}
                  {isPopulated(cat) && (
                    <img
                      className="completed-checkbox margin-left"
                      src={IconCompleted}
                      alt="deselect field"
                      width="12px"
                    />
                  )}
                </h2>
                <p className="profile-summary-item-description">
                  {summaries[cat.name]}
                </p>
              </div>
              <NavLink
                to={`/${cat.navlink}`}
                name={`/${cat.navlink}`}
                aria-label={`view /${cat.displayName}`}
              >
                <RightOutlined />
              </NavLink>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  // general
  const { email } = store.emailReducer;
  const { input } = store.inputReducer;

  const { userInterests } = store.interestsReducer;
  const { userSkills } = store.skillsReducer;
  const { userPersonality } = store.personalityReducer;
  const { userCareers } = store.careersReducer;
  const { userCourses } = store.coursesReducer;

  const { userRecSubs } = store.pickRecSubReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  const { userAddSubs } = store.pickAddSubReducer;

  return {
    // general
    email: email,
    input: input,

    // other user input
    userInterests: userInterests,
    userSkills: userSkills,
    userPersonality: userPersonality,
    userCareers: userCareers,
    userCourses: userCourses,

    userRecSubs: userRecSubs,
    userOthSubs: userOthSubs,
    userAddSubs: userAddSubs,
  };
};

export default connect(mapStateToProps)(ProfileSummary);
